import { makeVar } from '@apollo/client';

const exchangeStore = makeVar({
  completeForm: false,
  received: null,
});

export default exchangeStore;
